// extracted by mini-css-extract-plugin
export default {"LinkAccountPop":"LinkAccountPop_LinkAccountPop__Eh1qI","submit":"LinkAccountPop_submit__qCLx8"};